module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/sp-cover-2-64042eff54e5921a099616b7bc425ae9.webp";